import { getEnabledFeatures, isFeatureEnabled } from 'components/optimizely/service';

export const RECEIVE_FEATURE_FLAG = 'RECEIVE_FEATURE_FLAG';
export const RECEIVE_ENABLED_FEATURES = 'RECEIVE_ENABLED_FEATURES';

export function receiveFeatureFlagData(data) {
  return {
    type: RECEIVE_FEATURE_FLAG,
    data,
  };
}

function receiveEnabledFeatures(data) {
  return {
    type: RECEIVE_ENABLED_FEATURES,
    data,
  };
}

export function fetchFeatureFlag({ featureKey, userId, attributes = {} }) {
  return dispatch =>
    isFeatureEnabled({ featureKey, userId, attributes }).then((response) => {
      dispatch(receiveFeatureFlagData({ [featureKey]: response }));
    });
}

export function fetchEnabledFeatures({ userId, attributes = {} }) {
  return dispatch =>
    getEnabledFeatures({ userId, attributes }).then(response =>
      dispatch(receiveEnabledFeatures(response)));
}
